/**
 * @file src/const/paths.ts
 * @exports paths, ALLOWED_USER_PATHS, AUTH_PAGE_PATHS
 * @summary Path constants for the application.
 */

export const paths = {
	apiKeys: "/api-keys",
	auditLog: "/audit-log",
	backupCodes: "/backup-codes",
	createInvite: "/create-invite",
	notFound: "/404",
	home: "/invites", // This is the default route
	invites: "/invites",
	login: "/login",
	quickLogin: "/quick-login",
	quickLoginCode: "/quick-login-code",
	logout: "/logout",
	mfa: "/mfa",
	orders: "/orders",
	organizations: "/organizations",
	adverseActionEmail: "/organizations/[id]/adverse-action-email",
	pass: "/pass",
	postRegistration: "/post-registration",
	profileSettings: "/profile-settings",
	recovery: "/recovery",
	recoveryLinkSent: "/recovery-link-sent",
	resendResetCode: "/resend-reset-code",
	register: "/registration",
	quickRegistration: "/quick-registration",
	quickRegistrationCode: "/quick-registration-code",
	suborg: "/suborg",
	user: "/user",
	users: "/users",
	verification: "/verification",
	vid: "/vid",
	vidExpired: "/vid/expired",
	vidAdditionalInformation: "/vid/additional-information",
	vidAlmostDone: "/vid/almost-done",
	vidIdUpload: "/vid/id-upload",
	vidLanding: "/vid/landing",
	vidRemoteIdUpload: "/remote/id-upload",
	vidRemoteCaptureInit: "/vid/remote-capture-init",
	vidManualEntry: "/vid/manual-entry",
	vidTooManyScanAttempts: "/vid/too-many-scan-attempts",
	vidPersonalInformation: "/vid/personal-information",
	vidSelectIdType: "/vid/select-id-type",
	vidUsIdType: "/vid/us-id-type",
	vidInternationalIdType: "/vid/international-id-type",
	/** Next.js pathname pattern for `src/pages/vid/i/[invite].tsx`; keep filesystem and value in sync. */
	vidInvite: "/vid/i/[invite]",
	vidSelfie: "/vid/selfie",
	vidSignDisclosures: "/vid/sign-disclosures",
	vidSSN: "/vid/ssn",
	vidFeedback: "/vid/feedback",
	vidServiceUnavailable: "/vid/service-unavailable",
	vidSuccess: "/vid/success",
	vidVerifyEmail: "/vid/verify-email",
	vidWelcome: "/vid/welcome",
	settings: "/settings",
	svixPortal: "/svix",
	// Dispute Center
	dispute: "/dispute", // This is not a real route, but is used for allowing access to all dispute center routes
	disputeCenterAuth: "/dispute/[orgName]/auth/[orderId]",
	disputeCenterValidate: "/dispute/[orgName]/auth/[orderId]/validate",
	disputeCenterHome: "/dispute/[orgName]/[orderId]",
	disputeCenterReport: "/dispute/[orgName]/[orderId]/report",
	disputeCenterThankYou: "/dispute/[orgName]/thank-you",
	walletShare: "/wallet-share/[token]",
};

/** Auth page paths where the high-contrast theme should be activated. */
export const AUTH_PAGE_PATHS = new Set([
	paths.login,
	paths.register,
	paths.quickLogin,
	paths.quickLoginCode,
	paths.quickRegistration,
	paths.quickRegistrationCode,
	paths.recovery,
	paths.recoveryLinkSent,
	paths.resendResetCode,
	paths.verification,
	paths.settings,
	paths.mfa,
]);

// These are paths available to all users
export const ALLOWED_USER_PATHS = new Set([
	paths.backupCodes,
	paths.createInvite,
	paths.home,
	paths.invites,
	paths.login,
	paths.logout,
	paths.mfa,
	paths.notFound,
	paths.organizations,
	paths.pass,
	paths.postRegistration,
	paths.profileSettings,
	paths.recovery,
	paths.register,
	paths.suborg,
	paths.user,
	paths.users,
	paths.verification,
	paths.vid,
	paths.vidExpired,
	paths.vidAdditionalInformation,
	paths.vidAlmostDone,
	paths.vidIdUpload,
	paths.vidLanding,
	paths.vidRemoteIdUpload,
	paths.vidRemoteCaptureInit,
	paths.vidManualEntry,
	paths.vidTooManyScanAttempts,
	paths.vidPersonalInformation,
	paths.vidSelectIdType,
	paths.vidUsIdType,
	paths.vidInternationalIdType,
	paths.vidInvite,
	paths.vidSelfie,
	paths.vidSignDisclosures,
	paths.vidSSN,
	paths.vidFeedback,
	paths.vidServiceUnavailable,
	paths.vidSuccess,
	paths.vidVerifyEmail,
	paths.vidWelcome,
	// Dispute Center
	paths.dispute,
	paths.disputeCenterAuth,
	paths.disputeCenterValidate,
	paths.disputeCenterHome,
	paths.disputeCenterThankYou,
	paths.disputeCenterReport,
	paths.walletShare,
]);
